// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2Lk3j","resendInfoText":"OnGoingPaymentBox_resendInfoText__1rSFc"};